import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ExcelService } from "../../services/excel.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { AdminDashboardService } from "../../services/admin-dashboard.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-accounts",
  templateUrl: "./accounts.component.html",
  styleUrls: ["./accounts.component.scss"],
})
export class AccountsComponent implements OnInit {
  public selectedUser: any;
  public user: any;
  public users: [];
  public sortedUsers: any;
  public searchText: string;
  public activatedText: string;
  public showAllUsers: boolean;
  public userDetail: boolean;
  public collection = [];
  public searchData;
  public page: [];
  public pages: [];
  public total: [];
  public message: string;
  public usersFound: boolean;
  public usersFoundArray: any;
  public isSearching: boolean = false;
  public dataIsLoaded: boolean;
  public isSorting: boolean = false;
  public firstNameSorted: boolean;
  public lastNameSorted: boolean;
  public emailSorted: boolean;
  public sortedUsersArray: [];

  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private excelService: ExcelService,
    private ZpDataService: ZpDataService,
    private admin: AdminDashboardService,
    public themeService: ThemeService
  ) {
    this.users = [];
  }

  async ngOnInit() {
    this.showAllUsers = true;
    this.isSearching = false;
    await this.ZpDataService.getAllUsers().then((allUsers) => {
      this.page = allUsers.page;
      this.pages = allUsers.pages;
      this.total = allUsers.total;
      this.admin.users = allUsers.users;
      this.users = this.admin.users;
    });
    this.ZpDataService.getUser().then((user) => {
      this.user = user;
    });
    console.log("Users - ", this.users);
    console.log("Page - ", this.page);
  }

  onSelect(dataUser) {
    this.showAllUsers = false;
    this.selectedUser = dataUser;
    this.userDetail = true;
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.users, "Users");
  }

  displayUserData(event) {
    console.log(event, " - User data from child component");
  }

  backFromDetailUser() {
    this.showAllUsers = true;
    this.userDetail = false;
  }

  async searchByLastName(serachData) {
    this.dataIsLoaded = false;
    this.isSearching = true;
    let data = await this.ZpDataService.findUsers(null, serachData);
    this.dataIsLoaded = true;
    if (data.success && data.users.length > 0) {
      this.usersFoundArray = data.users;
      this.usersFound = true;
    } else {
      this.usersFound = false;
      this.message = "This user does not exist.";
    }
  }

  async sortColumns(columnName) {
    switch (columnName) {
      case "email":
        this.emailSorted = !this.emailSorted;
        if (this.emailSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"email":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"email":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        }
        break;
      case "firstName":
        this.firstNameSorted = !this.firstNameSorted;
        if (this.firstNameSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"firstName":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"firstName":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        }
        break;
      case "lastName":
        this.lastNameSorted = !this.lastNameSorted;
        if (this.lastNameSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"lastName":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"lastName":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.users = this.sortedUsersArray;
        }
        break;
    }
  }

  backToTable() {
    this.isSearching = false;
  }
}
